import React from 'react'

const Plant = () => {
  return (
    <div>Plant</div>
  )
}

export default Plant